<style lang="scss" scoped>
.switch-user-dialog {
  .btn_bottom {
    padding-bottom: 30px;
    text-align: right;
  }
}
</style>
<template>
  <el-dialog title="切换用户登录"
    class="switch-user-dialog"
    top="15vh"
    :visible.sync="dialogVisible"
    :append-to-body="true"
    :close-on-click-modal="false" :close-on-press-escape="false"
    :destroy-on-close="true"
    width="400px">
    <div class="dialog-wrap">
      <el-form :model="formData" label-width="80px"
        label-position="left"
        class="clearfix"
        size="medium">
        <el-form-item prop="open_id	" label="用户列表">
          <el-select v-model="formData.open_id" placeholder="请选择" style="width: 100%;"
            filterable>
            <el-option
              v-for="item in users"
              :key="item.open_id"
              :label="item.name"
              :value="item.open_id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="btn_bottom">
        <el-button type="primary" slot="reference" size="small"
          @click="confirmChangeUserHandler"
          :loading="btnIsLoading"
          style="margin-left: 10px;">确认切换
        </el-button>
        <el-button slot="reference" size="small" @click="dialogVisible = false"
          style="margin-left: 10px;">取 消
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getUsers } from '@/api/user'

export default {
  name: 'switchUserDialog',
  data() {
    return {
      dialogVisible: false,
      btnIsLoading: false,
      users: [],
      formData: {
        open_id: ''
      }
    }
  },
  mounted() {
    this.$on('open', (basic_type) => {
      this.dialogVisible = true
      this.initPage()
    })
  },
  methods: {
    initPage() {
      getUsers().then(res => {
        console.log(res)
        if (res.code != 0 || !Array.isArray(res.data)) return
        this.users = res.data
      }).catch(err => {
        console.error(err)
      })
    },
    confirmChangeUserHandler() {
      console.log(this.formData.open_id)
      if (!this.formData.open_id) {
        return this.$message({
          message: '请选择用户',
          type: 'error',
          dangerouslyUseHTMLString: true
        });
      }
      this.btnIsLoading = true
      this.$store.dispatch('switchLogin', this.formData.open_id).then(res => {
        if (res.code == 422) throw new Error(extract422Message(res.data));
        if (res.code != 0) throw new Error(res.message);
        location.href = '/approval'
      }).catch(err => {
        this.$message({
          message: err.response && err.response.data ? err.response.data.message : err.message,
          type: 'error',
          dangerouslyUseHTMLString: true
        });
      }).finally(item => {
        this.btnIsLoading = false
      })
    }
  }
}
</script>
